/**
 * Converts a date string in the format "MMM-YYYY" to "MM/YYYY". Designed specifically for the Pulses Charts.
 *
 * @param dateStr - The input date string in the format "MMM-YYYY".
 * @returns The formatted date string in the format "MM/YYYY" if the input is valid, otherwise `null`.
 */
export function formatDateString(dateStr: string) {
  const months = {
    Jan: "1",
    Feb: "2",
    Mar: "3",
    Apr: "4",
    May: "5",
    Jun: "6",
    Jul: "7",
    Aug: "8",
    Sep: "9",
    Oct: "10",
    Nov: "11",
    Dec: "12",
  }

  const [month, year] = dateStr.split("-")
  const monthNumber = months[month]

  return monthNumber ? `${monthNumber}/${year}` : null
}
